import { BKJThemeTextInput } from './../../components/BKJTextInput/BKJTextInput.theme.js';
import { BKJThemeListItem } from './../../components/BKJListItem/BKJListItem.theme.js';
import { css } from 'styled-components';
import { BKJThemeBadge } from '../../components/BKJBadge/BKJBadge.theme.js';
import { BKJThemeButton } from '../../components/BKJButton/BKJButton.theme.js';
import { BKJThemeCheckbox } from '../../components/BKJCheckbox/BKJCheckbox.theme.js';
import { BKJThemeCheck } from '../../components/BKJCheckbox/src/BKJCheck.theme.js';
import { BKJThemeChip } from '../../components/BKJChip/BKJChip.theme.js';
import { BKJThemeDialog } from '../../components/BKJDialog/BKJDialog.theme.js';
import { BKJThemeDropdown } from '../../components/BKJDropdown/BKJDropdown.theme.js';
import { BKJThemeHorizontalRule } from '../../components/BKJHorizontalRule/BKJHorizontalRule.types.js';
import { BKJThemeLoadingSpinner } from '../../components/BKJLoadingSpinner/BKJLoadingSpinner.theme.js';
import { BKJThemeSelect } from '../../components/BKJSelect/BKJSelect.theme.js';
import { BKJThemeToastMessage } from '../../components/BKJToastMessage/BKJToastMessage.theme.js';
import { BKJThemeToggle } from '../../components/BKJToggleInput/BKJToggleInput.theme.js';
import { BKJThemeTypography } from '../../components/BKJTypography/BKJTypography.theme.js';
import { CSS_VAR_MAP } from './BKJThemeProvider.cssVars.js';
export const BKJThemeColor = {
    TextDarkGrey: `var(${CSS_VAR_MAP.colors.TextDarkGrey})`,
    TextSubtleGrey: `var(${CSS_VAR_MAP.colors.TextSubtleGrey})`,
    TextDisabled: `var(${CSS_VAR_MAP.colors.TextDisabled})`,
    TextWhite: `var(${CSS_VAR_MAP.colors.TextWhite})`,
    TextHighlight1: `var(${CSS_VAR_MAP.colors.TextHighlight1})`,
    TextHighlight2: `var(${CSS_VAR_MAP.colors.TextHighlight2})`,
    ErrorClick: `var(${CSS_VAR_MAP.colors.ErrorClick})`,
    ErrorDefault: `var(${CSS_VAR_MAP.colors.ErrorDefault})`,
    ErrorHover: `var(${CSS_VAR_MAP.colors.ErrorHover})`,
    SuccessClick: `var(${CSS_VAR_MAP.colors.SuccessClick})`,
    SuccessDefault: `var(${CSS_VAR_MAP.colors.SuccessDefault})`,
    SuccessHover: `var(${CSS_VAR_MAP.colors.SuccessHover})`,
    PrimaryClick: `var(${CSS_VAR_MAP.colors.PrimaryClick})`,
    PrimaryDefault: `var(${CSS_VAR_MAP.colors.PrimaryDefault})`,
    PrimaryHover: `var(${CSS_VAR_MAP.colors.PrimaryHover})`,
    SecondaryPendingDefault: `var(${CSS_VAR_MAP.colors.SecondaryPendingDefault})`,
    SecondaryPendingHover: `var(${CSS_VAR_MAP.colors.SecondaryPendingHover})`,
    SecondaryPendingDraftHover: `var(${CSS_VAR_MAP.colors.SecondaryPendingDraftHover})`,
    SecondaryAcceptedDefault: `var(${CSS_VAR_MAP.colors.SecondaryAcceptedDefault})`,
    SecondaryAcceptedHover: `var(${CSS_VAR_MAP.colors.SecondaryAcceptedHover})`,
    SecondaryAcceptedDraftHover: `var(${CSS_VAR_MAP.colors.SecondaryAcceptedDraftHover})`,
    OtherDefault: `var(${CSS_VAR_MAP.colors.OtherDefault})`,
    OtherHover: `var(${CSS_VAR_MAP.colors.OtherHover})`,
    OtherDraftHover: `var(${CSS_VAR_MAP.colors.OtherDraftHover})`,
    WarningBackground: `var(${CSS_VAR_MAP.colors.WarningBackground})`,
    ErrorBackground: `var(${CSS_VAR_MAP.colors.ErrorBackground})`,
    NewlyEdited: `var(${CSS_VAR_MAP.colors.NewlyEdited})`,
    GreyDivider: `var(${CSS_VAR_MAP.colors.GreyDivider})`,
    Grey1: `var(${CSS_VAR_MAP.colors.Grey1})`,
    Grey2: `var(${CSS_VAR_MAP.colors.Grey2})`,
    Grey3: `var(${CSS_VAR_MAP.colors.Grey3})`,
    Grey4: `var(${CSS_VAR_MAP.colors.Grey4})`,
    Grey5: `var(${CSS_VAR_MAP.colors.Grey5})`,
    Grey6: `var(${CSS_VAR_MAP.colors.Grey6})`,
    Grey7: `var(${CSS_VAR_MAP.colors.Grey7})`,
    White: `var(${CSS_VAR_MAP.colors.White})`,
    AccentGreen: `var(${CSS_VAR_MAP.colors.AccentGreen})`,
    AccentBrand: `var(${CSS_VAR_MAP.colors.AccentBrand})`,
    AccentPurple: `var(${CSS_VAR_MAP.colors.AccentPurple})`,
    Transparent: `var(${CSS_VAR_MAP.colors.Transparent})`,
    ShiftInProgress: `var(${CSS_VAR_MAP.colors.ShiftInProgress})`,
    ShiftAccepted: `var(${CSS_VAR_MAP.colors.ShiftAccepted})`,
    ShiftAssigned: `var(${CSS_VAR_MAP.colors.ShiftAssigned})`,
    ShiftCancelled: `var(${CSS_VAR_MAP.colors.ShiftCancelled})`,
    ShiftCompleted: `var(${CSS_VAR_MAP.colors.ShiftCompleted})`,
    ShiftOpen: `var(${CSS_VAR_MAP.colors.ShiftOpen})`,
    ShiftPending: `var(${CSS_VAR_MAP.colors.ShiftPending})`,
    ShiftRejected: `var(${CSS_VAR_MAP.colors.ShiftRejected})`,
    ShiftRequested: `var(${CSS_VAR_MAP.colors.ShiftRequested})`,
    ShiftUnfulfilled: `var(${CSS_VAR_MAP.colors.ShiftUnfulfilled})`,
    ShiftTimeOff: `var(${CSS_VAR_MAP.colors.ShiftTimeOff})`,
    ShiftOtherPosition: `var(${CSS_VAR_MAP.colors.ShiftOtherPosition})`,
    ShiftUnfulfilledStroke: `var(${CSS_VAR_MAP.colors.ShiftUnfulfilledStroke})`,
    ShiftSwapped: `var(${CSS_VAR_MAP.colors.ShiftSwapped})`,
    ShiftAbsent: `var(${CSS_VAR_MAP.colors.ShiftAbsent})`,
    ShiftPendingBlock: `var(${CSS_VAR_MAP.colors.ShiftPendingBlock})`,
};
export const BKJThemeFont = {
    PoppinsSemiBold: css `
    font-family: 'Poppins SemiBold';
    font-weight: normal;
    font-style: normal;
  `,
    PoppinsMedium: css `
    font-family: 'Poppins Medium';
    font-weight: 400;
    font-style: normal;
  `,
    Poppins: css `
    font-family: 'Poppins Medium';
    font-weight: normal;
    font-style: normal;
  `,
    PoppinsLight: css `
    font-family: 'Poppins Medium';
    font-weight: 300;
    font-style: normal;
  `,
    PoppinsBold: css `
    font-family: 'Poppins SemiBold';
    font-weight: bold;
    font-style: normal;
  `,
    PoppinsText: css `
    font-family: 'Poppins Medium';
    font-weight: normal;
    font-style: normal;
  `,
    PoppinsTextLight: css `
    font-family: 'Poppins Medium';
    font-weight: 300;
    font-style: normal;
  `,
    PoppinsTextMedium: css `
    font-family: 'Poppins Medium';
    font-weight: normal;
    font-style: normal;
  `,
    PoppinsTextBold: css `
    font-family: 'Poppins SemiBold';
    font-weight: bold;
    font-style: normal;
  `,
};
export const BKJThemeShadows = {
    Default: css `
    box-shadow: 0px 2px 8px rgba(13, 51, 32, 0.3);
  `,
    DropdownBase: css `
    box-shadow: 0px 2px 8px 0px #0d33204d;
  `,
    InnerShadow: css `
    box-shadow: inset 0px -2px 4px rgba(0, 0, 0, 0.05);
  `,
    TableShadow: css `
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  `,
};
export const BKJThemeColumns = {
    TwelveColumn: css `
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  `,
    TenColumn: css `
    display: grid;
    grid-template-columns: repeat(10, 1fr);
  `,
    EightColumn: css `
    display: grid;
    grid-template-columns: repeat(8, 1fr);
  `,
    SixColumn: css `
    display: grid;
    grid-template-columns: repeat(6, 1fr);
  `,
    FourColumn: css `
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  `,
    ThreeColumn: css `
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  `,
    TwoColumn: css `
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  `,
};
export const BKJThemeBorders = {
    DefaultBorder: css `
    border-radius: 8px;
  `,
    RoundBorder: css `
    border-radius: 99px;
  `,
    BoxBorder: css `
    border-radius: 2px;
  `,
};
export const BKJThemeBreakpoints = {
    Mobile: '500px',
    Tablet: '768px',
    Desktop: '1024px',
};
export const BKJThemeSpacings = {
    Spacing4: `var(${CSS_VAR_MAP.spacing.Spacing4})`,
    Spacing8: `var(${CSS_VAR_MAP.spacing.Spacing8})`,
    Spacing16: `var(${CSS_VAR_MAP.spacing.Spacing16})`,
    Spacing24: `var(${CSS_VAR_MAP.spacing.Spacing24})`,
    Spacing32: `var(${CSS_VAR_MAP.spacing.Spacing32})`,
    Spacing40: `var(${CSS_VAR_MAP.spacing.Spacing40})`,
};
export const BKJThemeCommon = {
    Ellipsis: css `
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  `,
};
export const BKJTheme = {
    __discriminator: 'BKJThemeType',
    loadingSpinner: BKJThemeLoadingSpinner,
    badge: BKJThemeBadge,
    button: BKJThemeButton,
    textInput: BKJThemeTextInput,
    dialog: BKJThemeDialog,
    check: BKJThemeCheck,
    checkbox: BKJThemeCheckbox,
    chip: BKJThemeChip,
    dropdown: BKJThemeDropdown,
    hr: BKJThemeHorizontalRule,
    fonts: BKJThemeFont,
    colors: BKJThemeColor,
    typography: BKJThemeTypography,
    select: BKJThemeSelect,
    shadows: BKJThemeShadows,
    columns: BKJThemeColumns,
    borders: BKJThemeBorders,
    spacing: BKJThemeSpacings,
    breakpoints: BKJThemeBreakpoints,
    common: BKJThemeCommon,
    toast: BKJThemeToastMessage,
    toggle: BKJThemeToggle,
    listItem: BKJThemeListItem,
};
//# sourceMappingURL=BKJThemeProvider.theme.js.map